var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('div',[_c('FormHelper',{ref:"form",staticClass:"pb-5",attrs:{"form":_vm.form,"config":_vm.config,"no-data-text":_vm.$t('mapping.noTransformersAvailable')},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }